import { Inject, Injectable } from '@angular/core';
import { CUSTOMER_REPOSITORY, CustomersRepository } from '@core/repositories/customers.repository';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomersService {
  constructor(
    @Inject(CUSTOMER_REPOSITORY) protected repository: CustomersRepository
  ) {}

  getItems(): Observable<any> {
    return this.repository.getItems();
  }

  getItemId(typeIdentify: string, identify: string): Observable<any> {
    return this.repository.getItemId(typeIdentify, identify);
  }

  getTypeIdentify(): Observable<any> {
    return this.repository.getTypeIdentify();
  }
}
